export function updateTask(data) {
    return new Promise((resolve, reject) => {
        let { updateTaskRequest, updateTaskError, updateTaskResult } = this.props

        this.doAction(
            this.WEB_REQUEST_URL + 'update_task',
            this.createBundle(
                'update_task',
                { task: data },
                this.POST,
                updateTaskRequest,
                (result) => {
                    updateTaskResult(result)
                    resolve(result)
                },
                (error) => {
                    updateTaskError(error)
                    reject(error)
                }
            )
        )
    })
}
